var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, ViewChild, Input } from '@angular/core';
import { Http } from '@angular/http';
import { Escrito } from '../../model/escrito';
import { CommonService, SFUN } from '../../services/common.service';
import { ExpedienteService } from '../../services/expediente.service';
import { TasasService } from '../../services/tasas.service';
import { ActuacionService } from '../../services/actuacion.service';
import { KeycloakService } from '../../services/keycloak.service';
import { EscritoPresentarComponent } from '../escrito/escrito-presentar.component';
import { ActuacionPopupComponent } from '../actuacion/actuacion-popup.component';
import { EscritoPopupComponent } from '../escrito/escrito-popup.component';
import { TasasPopupComponent } from '../tasa/tasa-popup.component';
import { SIGNER_STATUS } from '../../common/firmador/firma-helper.component';
import { Subscription } from 'rxjs';
import { AppComponent } from '../../app.component';
import { ServiceException } from '../../model/exception';
import { Message } from '../../common/dialog/mensaje.component';
import { MensajeConfig, BUTTON_CLICK } from '../../common/dialog/mensaje.config';
import { PopupRecaptcha } from '../../common/recaptcha/popup-recaptcha';
import { SharedService } from '../../services/shared.service';
import { Novedad } from '../../model/novedad';
import { ExpedienteDownloadComponent } from './expediente-download.component';
import { WebSocketService } from '../../services/websocket.service';
import { RepresentanteQrPopupComponent } from '../parte/representante-qr-popup.component';
var form;
var ExpedienteViewComponent = (function () {
    function ExpedienteViewComponent(_http, _tService, _expService, _actService, _comService, _ws) {
        this._http = _http;
        this._tService = _tService;
        this._expService = _expService;
        this._actService = _actService;
        this._comService = _comService;
        this._ws = _ws;
        this.subscription = new Subscription();
        this.subscription2 = new Subscription();
        this.showToolbar = true;
        this.showToolbarMenu = true;
        this.mostrarZocalo = true;
        this.mostrarZocaloDespacho = false;
        this.curPage = 0;
        this.curPageEsc = 0;
        this.curPagePases = 0;
        this.curPageRegistroPaseEstudio = 0;
        this.cantPages = 0;
        this.cantPagesEsc = 0;
        this.cantPagesPases = 0;
        this.cantPagesRegistroPaseEstudio = 0;
        this.curPageSaldos = 0;
        this.cantPagesSaldos = 0;
        this.showList = false;
        this.verEscritos = false;
        this.verActuaciones = false;
        this.abrirTasas = false;
        this.permisoFav = true;
        this.permisoAct = true;
        this.permisoEsc = true;
        this.permisoPartes = true;
        this.permisoTas = true;
        this.permisoAud = true;
        this.permisoAltaTas = true;
        this.permisoBtnPagTas = true;
        this.permisoDescarga = true;
        this.permisoOrdenaGrillaAct = true;
        this.noEsOculto = true;
        this.mostrarPartes = true;
        this.mostrarComp = false;
        this.mostrarBtnAltaTas = false;
        this.org_activo = true;
        this.permisoDescargaPersonalizada = false;
        this.permisoRepresentanteQr = false;
        this.permisoPases = true;
        this.permisoSaldos = true;
        this.permisoRegistroPaseEstudio = true;
        this.isCollapsedContent = true;
        this.mensajeSaldo = "";
        this.orderByColumn = '';
        this.orderByDirection = ''; // valores posibles: asc o desc
        this.boldFilaActAcumulado = false; //muestra en negrita la fila de las actuaciones de expedientes acumulados
        this.boldCeldaActAcumulado = false; //muestra en negrita la celda 'Acumulado' de las actuaciones de expedientes acumulados
        this.usarDescargaExpWS = false; //en true utiliza websocket en la descarga del expediente
        this.sessionId = "";
        this.uuidDescargaThread = "";
        this.instanceId = Math.floor(Math.random() * 1000000);
    }
    ExpedienteViewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.mostrarComp = SharedService.getProp("botonComp");
        //console.log("BOTON COMP " + this.mostrarComp);
        this.boldFilaActAcumulado = this._comService.getConfiguracion('ACTROWBOLD') == 'true';
        this.boldCeldaActAcumulado = this._comService.getConfiguracion('ACTCELBOLD') == 'true';
        this.usarDescargaExpWS = this._comService.getConfiguracion('DEXPASYNC') == 'true';
        this._subscription = AppComponent.observable().subscribe(function (item) { return _this.setPermisos(item); });
        this._expService.findExpediente(this.expId, KeycloakService.getLoggedUser()).subscribe(function (response) {
            _this.expediente = response;
            if (_this.expediente.nivacc == 1) {
                _this.mostrarPartes = false;
            }
            if (_this.expediente.org_activebf === 0) {
                _this.org_activo = false;
            }
            _this.getPartes();
            _this.setPermisos(true);
        });
        this._expService.findNoticiaExp(this.expId).subscribe(function (response) {
            _this.noticias = response;
        });
        //this.connectWS();
    };
    ExpedienteViewComponent.prototype.setPermisos = function (val) {
        if (typeof (KeycloakService.usr) !== 'undefined' && typeof (KeycloakService.usr.permisos) !== 'undefined') {
            this.permisoFav = this._comService.tienePermiso(SFUN.Favoritos);
            this.permisoAct = this._comService.tienePermiso(SFUN.Actuaciones);
            this.permisoEsc = this._comService.tienePermiso(SFUN.Escritos);
            this.permisoPartes = this._comService.tienePermiso(SFUN.Partes);
            this.permisoTas = this._comService.tienePermiso(SFUN.Tasas);
            this.permisoAud = this._comService.tienePermiso(SFUN.Audiencia);
            this.permisoAltaTas = this._comService.tienePermiso(SFUN.AltaTasa);
            this.permisoDescarga = this._comService.tienePermiso(SFUN.DesExp);
            this.permisoBtnPagTas = this._comService.tienePermiso(SFUN.PagarTasa);
            this.permisoOrdenaGrillaAct = this._comService.tienePermiso(SFUN.ActOrdenarGrilla);
            this.permisoDescargaPersonalizada = this._comService.tienePermiso(SFUN.DesExpPer);
            this.permisoRepresentanteQr = this._comService.tienePermiso(SFUN.ExpRepQR);
            this.permisoPases = this._comService.tienePermiso(SFUN.Pases);
            this.permisoSaldos = this._comService.tienePermiso(SFUN.Saldos);
            this.permisoRegistroPaseEstudio = this._comService.tienePermiso(SFUN.RegistroPaseEstudio);
        }
    };
    ExpedienteViewComponent.prototype.getStyleAct = function (nav) {
        var classes = "tab-pane";
        if (nav) {
            classes = "nav-link";
        }
        if (this.permisoAct) {
            classes = "active " + classes;
        }
        return classes;
    };
    ExpedienteViewComponent.prototype.isAcumulado = function (actuacion) {
        return actuacion.acumulado != null;
    };
    ExpedienteViewComponent.prototype.getStyleEsc = function (nav) {
        var classes = "tab-pane";
        if (nav) {
            classes = "nav-link";
        }
        if (!this.permisoAct) {
            classes = "active " + classes;
        }
        return classes;
    };
    ExpedienteViewComponent.prototype.getStyleParte = function (nav) {
        var classes = "tab-pane";
        if (nav) {
            classes = "nav-link";
        }
        if (!this.permisoPartes) {
            classes = "active " + classes;
        }
        return classes;
    };
    ExpedienteViewComponent.prototype.getStyleTas = function (nav) {
        var classes = "tab-pane";
        if (nav) {
            classes = "nav-link";
        }
        if (!this.permisoTas) {
            classes = "active " + classes;
        }
        return classes;
    };
    ExpedienteViewComponent.prototype.getStyleAud = function (nav) {
        var classes = "tab-pane";
        if (nav) {
            classes = "nav-link";
        }
        if (!this.permisoAud) {
            classes = "active " + classes;
        }
        return classes;
    };
    ExpedienteViewComponent.prototype.getStylePases = function (nav) {
        var classes = "tab-pane";
        if (nav) {
            classes = "nav-link";
        }
        if (!this.permisoPases) {
            classes = "active " + classes;
        }
        return classes;
    };
    ExpedienteViewComponent.prototype.getStyleSaldos = function (nav) {
        var classes = "tab-pane";
        if (nav) {
            classes = "nav-link";
        }
        if (!this.permisoPases) {
            classes = "active " + classes;
        }
        return classes;
    };
    ExpedienteViewComponent.prototype.getStyleRegistroPaseEstudio = function (nav) {
        var classes = "tab-pane";
        if (nav) {
            classes = "nav-link";
        }
        if (!this.permisoRegistroPaseEstudio) {
            classes = "active " + classes;
        }
        return classes;
    };
    ExpedienteViewComponent.prototype.mostrarOcultarBtnAgregarTasas = function (mostrar) {
        this.mostrarBtnAltaTas = mostrar;
    };
    ExpedienteViewComponent.prototype.onClickOpenExp = function () {
        if (SharedService.getProp("useRecaptcha")) {
            if (this.isCollapsedContent && this.noEsOculto) {
                if (this._comService.cantApExp >= this._comService.getCantAperturaExp()) {
                    this._comService.addTimeExp(new Date().getTime());
                    this._comService.cantApExp = 0;
                    //------------------------------------------------
                    this.targetOpenExp = '#captcha-popup-' + this.instanceId;
                    document.getElementById("openCaptchaExp").click();
                    // this.captchaPopup.onClose.subscribe((event) => { this.openExp(); });
                    // this.captchaPopup.load();
                    //-------------------------------------------------
                    // this.modalCaptcha.id = String(this.expId);
                    // // this.subscription2 = new Subscription();
                    // // this.subscription2.add(
                    // //     this.modalCaptcha.onClose.subscribe((event) => { 
                    // //         console.log("subscribe " + event);
                    // //         this.openExp(); 
                    // //         this.subscription2.unsubscribe();
                    // //     })
                    // // );
                    // this.modalCaptcha.onClose.subscribe((event) => { this.openExp(); });
                    // this.modalCaptcha.open();                    
                    //--------------------------------------------------
                }
                else {
                    if (this.noEsOculto) {
                        this.targetOpenExp = '';
                        this.isCollapsedContent = false;
                        this._comService.cantApExp = this._comService.cantApExp + 1;
                        this.getExpContent();
                    }
                }
            }
            else {
                //this.targetOpenExp = '';
                this.isCollapsedContent = true;
            }
        }
        else {
            if (this.noEsOculto) {
                this.isCollapsedContent = !this.isCollapsedContent;
                if (!this.isCollapsedContent) {
                    this.getExpContent();
                }
            }
        }
    };
    ExpedienteViewComponent.prototype.openExpFromCaptcha = function () {
        this.isCollapsedContent = false;
        //this._comService.cantApExp = this._comService.cantApExp + 1;
        if (this.noEsOculto) {
            this._comService.chequearEnvioMail("EXP");
            this._comService.addAuditoria("RECEXP").subscribe(function (response) {
                var res = response;
            });
            this.getExpContent();
        }
    };
    ExpedienteViewComponent.prototype.openCaptchaExp = function () {
        var _this = this;
        //this.captchaPopup.onClose.subscribe((event) => { this.openExp(); });
        this.subscription2 = new Subscription();
        this.subscription2.add(this.captchaPopup.onClose.subscribe(function (event) {
            _this.openExpFromCaptcha();
            _this.subscription2.unsubscribe();
        }));
        this.captchaPopup.load();
    };
    ExpedienteViewComponent.prototype.onClickOpenAdj = function (id) {
    };
    ExpedienteViewComponent.prototype.onClickOpenAct = function (id) {
        this.idActOpenPopup = id;
        if (SharedService.getProp("useRecaptcha")) {
            if (this._comService.cantApAct >= this._comService.getCantAperturaAct()) {
                this._comService.addTimeAct(new Date().getTime());
                this._comService.cantApAct = 0;
                // this.targetOpenAct = '#captcha-popup-' + this.instanceId;
                // this.subscription = new Subscription();
                // this.subscription.add(
                //    this.captchaPopup.onClose.subscribe((event) => { 
                //        this.openAct(id); 
                //        this.subscription.unsubscribe();
                //    })
                // );
                // this.captchaPopup.load();
                // //this.captchaPopup.onClose.subscribe((event) => { this.openAct(id); });
                document.getElementById("openCaptchaActButton").click();
                // ----------------------------------------------------
                // this.modalCaptchaAct.id = id;
                // this.subscription = new Subscription();
                // this.subscription.add(
                //    this.modalCaptchaAct.onClose.subscribe((event) => { 
                //        this.openAct(id); 
                //        this.subscription.unsubscribe();
                //    })
                // );
                // this.modalCaptchaAct.open();
                // ----------------------------------------------------
            }
            else {
                //this.idActOpenPopup = id;
                document.getElementById("openActButton").click();
                //------------------------------------
                //this.openAct(id);
                // -----------------------------------
                this._comService.cantApAct = this._comService.cantApAct + 1;
            }
        }
        else {
            //this.idActOpenPopup = id;
            document.getElementById("openActButton").click();
            //------------------------------------
            // this.openAct(id);
        }
    };
    ExpedienteViewComponent.prototype.openCaptchaAct = function () {
        var _this = this;
        //this.captchaPopup.onClose.subscribe((event) => { this.openActFromCaptcha(this.idActOpenPopup); });
        this.subscription = new Subscription();
        this.subscription.add(this.captchaPopup.onClose.subscribe(function (event) {
            _this.openActFromCaptcha(_this.idActOpenPopup);
            _this.subscription.unsubscribe();
        }));
        this.captchaPopup.load();
    };
    ExpedienteViewComponent.prototype.openActFromCaptcha = function (id) {
        this.idActOpenPopup = id;
        document.getElementById("openActButton").click();
        // ---------------------------------------
        //this.actModal.open(id);
        // ---------------------------------------
        this._comService.chequearEnvioMail("ACT");
        this._comService.addAuditoria("RECACT").subscribe(function (response) {
            var res = response;
        });
    };
    ExpedienteViewComponent.prototype.openAct = function (id, video) {
        this.actPopup.video = video;
        if (video) {
            this.actPopup.expediente = this.expediente.tipo + " " + this.expediente.numero + "/" + this.expediente.anio;
            this.actPopup.caratula = this.expediente.caratula;
            this.actPopup.organismo = this.expediente.organismoActual;
            this.verificarVideo(id);
        }
        else {
            this.actPopup.loadAct(id);
        }
    };
    ExpedienteViewComponent.prototype.verificarVideo = function (id) {
        var _this = this;
        this._actService.verificarVideo(id, KeycloakService.getLoggedUser()).subscribe(function (response) {
            //console.log(response);
            var result = response;
            if (result.tipo == "T") {
                _this.actPopup.ticket = result.mensaje;
                _this.actPopup.loadAct(id);
            }
            else if (result.tipo == "M") {
                $('#act-popup-' + _this.instanceId).modal({
                    backdrop: 'static',
                    keyboard: false
                });
                $('#act-popup-' + _this.instanceId).modal('hide');
                _this.mensajeConfigSource = new MensajeConfig("Actuación", false, "", true, "Aceptar");
                _this.msgPopupAct.showMessage(result.mensaje);
            }
            else {
                _this.actPopup.video = false;
                _this.actPopup.loadAct(id);
            }
        });
    };
    ExpedienteViewComponent.prototype.closePopupAct = function (id) {
        this.actPopup.finalize();
    };
    ExpedienteViewComponent.prototype.onClickShowActPopup = function (id) {
        this.actPopup.loadAct(id);
    };
    ExpedienteViewComponent.prototype.onClickOpenNovedad = function (id) {
        if (this.noEsOculto) {
            //console.log("id de la act " + id); 
            this.actPopup.loadAct(id);
            $('#act-popup-' + this.instanceId).modal({
                backdrop: 'static',
                keyboard: false
            });
            $('#act-popup-' + this.instanceId).modal('show');
        }
    };
    ExpedienteViewComponent.prototype.getExpContent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a, exp;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.abrirTasas = true;
                        this.msgPopup.onClick.subscribe(function (event) { _this.onConfirmMonto(event); });
                        this.tasPopup.onRefresh.subscribe(function (event) { _this.refreshExp(event); });
                        this.mensajeConfigSource = new MensajeConfig("Tasas Judiales");
                        this.getTasas();
                        this.getActuaciones();
                        this.getEscritos();
                        this.getAudiencias();
                        this.getPases();
                        if (!this.permisoSaldos) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this._comService.getConfiguracion("EXP_CTA_MSJ")];
                    case 1:
                        _a.mensajeSaldo = _b.sent();
                        this.getSaldos();
                        _b.label = 2;
                    case 2:
                        if (this.permisoRegistroPaseEstudio) {
                            this.getRegistroPaseEstudio();
                        }
                        this._comService.addAuditoria("VISEXP").subscribe(function (response) {
                            var res = response;
                        });
                        exp = 'Expediente ' + this.expediente.organismo + ' ' + this.expediente.tipo + ' ' + this.expediente.numero + '/' + this.expediente.anio;
                        this._comService.addActivity(exp).subscribe(function (response) {
                            //console.log("se agrego actovity");
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ExpedienteViewComponent.prototype.refreshExp = function (event) {
        if (event != null)
            this.expediente.monto = event;
    };
    ExpedienteViewComponent.prototype.getPartes = function () {
        var _this = this;
        this._expService.findPartes(this.expId).subscribe(function (response) {
            _this.partes = response;
            //console.log("usr anon: " + KeycloakService.usr.codigo);
            if (_this.expediente.nivacc === 2 && !_this.esParte()) {
                _this.noEsOculto = false;
            }
            if (KeycloakService.usr.codigo.toUpperCase() === "anonimo".toUpperCase()) {
                _this.noEsOculto = false;
            }
        });
    };
    ExpedienteViewComponent.prototype.esParte = function () {
        var esta = false;
        //console.log("PARTES " + JSON.stringify(this.partes));
        //console.log("KEYCLOAK usr " + JSON.stringify(KeycloakService.usr));
        loop: {
            for (var i = 0; i < this.partes.length; i++) {
                //if (KeycloakService.usr.codRep != null){
                if (KeycloakService.usr.repCodigos != null && KeycloakService.usr.repCodigos.indexOf(this.partes[i].rep_codigo) >= 0) {
                    esta = true;
                    break loop;
                }
                else {
                    if ((KeycloakService.usr.tipoDoc + "-" + KeycloakService.usr.documento).indexOf(this.partes[i].tdo_cod + "-" + this.partes[i].numero) >= 0) {
                        esta = true;
                        break loop;
                    }
                }
            }
        }
        //console.log("es parte " + esta);
        return esta;
    };
    ExpedienteViewComponent.prototype.getTasas = function () {
        var _this = this;
        this._expService.findTasas(this.expId).subscribe(function (response) {
            _this.tasas = response;
        });
    };
    ExpedienteViewComponent.prototype.getAudiencias = function () {
        var _this = this;
        this._expService.findAudiencias(this.expId).subscribe(function (response) {
            _this.audiencias = response;
        });
    };
    ExpedienteViewComponent.prototype.getEscritos = function () {
        var _this = this;
        //this._expService.findEscritos(this.expId, 0, 5).subscribe(response => {
        this._expService.findEscritosByUsr(this.expId, 0, 5, KeycloakService.getLoggedUser()).subscribe(function (response) {
            _this.escritos = response;
            _this.pagesEsc = new Array(Math.ceil(_this.escritos.total / _this.escritos.size)).map(function (x, i) { return i; });
            _this.curPageEsc = 0;
            _this.cantPagesEsc = _this.pagesEsc.length - 1;
            _this.verEscritos = _this.escritos.total > 0;
        });
    };
    ExpedienteViewComponent.prototype.getActuaciones = function () {
        var _this = this;
        this._expService.findActuaciones(this.expId, 0, 10, this.orderByColumn, this.orderByDirection).subscribe(function (response) {
            _this.actuaciones = response;
            _this.pages = new Array(Math.ceil(_this.actuaciones.total / _this.actuaciones.size)).map(function (x, i) { return i; });
            _this.curPage = 0;
            _this.cantPages = _this.pages.length - 1;
            _this.verActuaciones = _this.actuaciones.total > 0;
            //console.log(this.actuaciones);
            //console.log("pages " + this.cantPages);
        });
    };
    ExpedienteViewComponent.prototype.getPases = function () {
        var _this = this;
        this._expService.findPases(this.expId, 0, 5).subscribe(function (response) {
            _this.pases = response;
            _this.pagesPases = new Array(Math.ceil(_this.pases.total / _this.pases.size)).map(function (x, i) { return i; });
            _this.curPagePases = 0;
            _this.cantPagesPases = _this.pagesPases.length - 1;
        });
    };
    ExpedienteViewComponent.prototype.getSaldos = function () {
        var _this = this;
        this._expService.findSaldos(this.expId).subscribe(function (response) {
            if (response.total != 0) {
                _this.saldos = response;
                _this.pagesSaldos = new Array(Math.ceil(_this.saldos.total / _this.saldos.size)).map(function (x, i) { return i; });
                _this.curPageSaldos = 0;
                _this.cantPagesSaldos = _this.pagesSaldos.length - 1;
            }
        });
    };
    ExpedienteViewComponent.prototype.getRegistroPaseEstudio = function () {
        var _this = this;
        this._expService.findRegistroPaseEstudio(this.expId, 0, 5).subscribe(function (response) {
            if (response.total != 0) {
                _this.registroPaseEstudio = response;
                _this.pagesRegistroPaseEstudio = new Array(Math.ceil(_this.registroPaseEstudio.total / _this.registroPaseEstudio.size)).map(function (x, i) { return i; });
                _this.curPageRegistroPaseEstudio = 0;
                _this.cantPagesRegistroPaseEstudio = _this.pagesRegistroPaseEstudio.length - 1;
            }
        });
    };
    //ordenar tabla de actuaciones por encabezado
    ExpedienteViewComponent.prototype.sortTable = function (column) {
        if (this.permisoOrdenaGrillaAct) {
            if (this.orderByColumn == column) {
                this.orderByDirection = this.orderByDirection == 'asc' ? 'desc' : 'asc';
                //console.log('va por el if, cambia direccion');
                //console.log("columna", this.orderByColumn);
                //console.log("direccion",this.orderByDirection);
            }
            else {
                this.orderByColumn = column;
                this.orderByDirection = 'asc';
                //console.log('va por el else, cambia columna y direccion');
                //console.log("columna", this.orderByColumn);
                //console.log("direccion",this.orderByDirection);
            }
            this.getActuaciones();
        }
    };
    ExpedienteViewComponent.prototype.getSortDirection = function (column) {
        if (this.permisoOrdenaGrillaAct && this.orderByColumn === column) {
            if (this.orderByDirection == 'asc') {
                return "fa fa-arrow-up";
            }
            else if (this.orderByDirection == 'desc') {
                return "fa fa-arrow-down";
            }
        }
        else {
            return '';
        }
    };
    //reestablecer el orden de la tabla de actuaciones 
    ExpedienteViewComponent.prototype.resetSortTable = function () {
        if (this.permisoOrdenaGrillaAct) {
            this.orderByColumn = '';
            this.orderByDirection = '';
            this.getActuaciones();
        }
    };
    ExpedienteViewComponent.prototype.getClassItem = function (i) {
        var classes = "page-item";
        if (this.curPage === i) {
            classes = "active " + classes;
        }
        return classes;
    };
    ExpedienteViewComponent.prototype.getClassItemEs = function (i) {
        var classes = "page-item";
        if (this.curPageEsc === i) {
            classes = "active " + classes;
        }
        return classes;
    };
    ExpedienteViewComponent.prototype.getClassItemPases = function (i) {
        var classes = "page-item";
        if (this.curPagePases === i) {
            classes = "active " + classes;
        }
        return classes;
    };
    ExpedienteViewComponent.prototype.getClassItemSaldos = function (i) {
        var classes = "page-item";
        if (this.curPageSaldos === i) {
            classes = "active " + classes;
        }
        return classes;
    };
    ExpedienteViewComponent.prototype.getClassItemRegistroPaseEstudio = function (i) {
        var classes = "page-item";
        if (this.curPageRegistroPaseEstudio === i) {
            classes = "active " + classes;
        }
        return classes;
    };
    ExpedienteViewComponent.prototype.prevPage = function () {
        var _this = this;
        //console.log("click previo");
        if (this.curPage > 0) {
            this.curPage = this.curPage - 1;
            this._expService.findActuaciones(this.expId, this.curPage, 10, this.orderByColumn, this.orderByDirection).subscribe(function (response) {
                _this.actuaciones = response;
                _this.pages = new Array(Math.ceil(_this.actuaciones.total / _this.actuaciones.size)).map(function (x, i) { return i; });
            });
        }
    };
    ExpedienteViewComponent.prototype.goToPage = function (index) {
        var _this = this;
        this._expService.findActuaciones(this.expId, index, 10, this.orderByColumn, this.orderByDirection).subscribe(function (response) {
            _this.actuaciones = response;
            _this.pages = new Array(Math.ceil(_this.actuaciones.total / _this.actuaciones.size)).map(function (x, i) { return i; });
            _this.curPage = index;
        });
    };
    ExpedienteViewComponent.prototype.nextPage = function () {
        var _this = this;
        if (this.curPage < this.pages.length) {
            this.curPage = this.curPage + 1;
            this._expService.findActuaciones(this.expId, this.curPage, 10, this.orderByColumn, this.orderByDirection).subscribe(function (response) {
                _this.actuaciones = response;
                _this.pages = new Array(Math.ceil(_this.actuaciones.total / _this.actuaciones.size)).map(function (x, i) { return i; });
            });
        }
    };
    ExpedienteViewComponent.prototype.prevPageEsc = function () {
        var _this = this;
        if (this.curPageEsc > 0) {
            this.curPageEsc = this.curPageEsc - 1;
            //this._expService.findEscritos(this.expId, this.curPageEsc, 5).subscribe(response => {
            this._expService.findEscritosByUsr(this.expId, this.curPageEsc, 5, KeycloakService.getLoggedUser()).subscribe(function (response) {
                _this.escritos = response;
                _this.pagesEsc = new Array(Math.ceil(_this.escritos.total / _this.escritos.size)).map(function (x, i) { return i; });
            });
        }
    };
    ExpedienteViewComponent.prototype.goToPageEsc = function (index) {
        var _this = this;
        //this._expService.findEscritos(this.expId, index, 5).subscribe(response => {
        this._expService.findEscritosByUsr(this.expId, index, 5, KeycloakService.getLoggedUser()).subscribe(function (response) {
            _this.escritos = response;
            _this.pagesEsc = new Array(Math.ceil(_this.escritos.total / _this.escritos.size)).map(function (x, i) { return i; });
            _this.curPageEsc = index;
        });
    };
    ExpedienteViewComponent.prototype.nextPageEsc = function () {
        var _this = this;
        if (this.curPageEsc < this.pagesEsc.length) {
            this.curPageEsc = this.curPageEsc + 1;
            //this._expService.findEscritos(this.expId, this.curPageEsc, 5).subscribe(response => {
            this._expService.findEscritosByUsr(this.expId, this.curPageEsc, 5, KeycloakService.getLoggedUser()).subscribe(function (response) {
                _this.escritos = response;
                _this.pagesEsc = new Array(Math.ceil(_this.escritos.total / _this.escritos.size)).map(function (x, i) { return i; });
            });
        }
    };
    ExpedienteViewComponent.prototype.prevPagePases = function () {
        var _this = this;
        if (this.curPagePases > 0) {
            this.curPagePases = this.curPagePases - 1;
            this._expService.findPases(this.expId, this.curPagePases, 5).subscribe(function (response) {
                _this.pases = response;
                _this.pagesPases = new Array(Math.ceil(_this.pases.total / _this.pases.size)).map(function (x, i) { return i; });
            });
        }
    };
    ExpedienteViewComponent.prototype.prevPageSaldos = function () {
        var _this = this;
        if (this.curPageSaldos > 0) {
            this.curPageSaldos = this.curPageSaldos - 1;
            this._expService.findSaldos(this.expId, this.curPageSaldos, 5).subscribe(function (response) {
                _this.saldos = response;
                _this.pagesSaldos = new Array(Math.ceil(_this.saldos.total / _this.saldos.size)).map(function (x, i) { return i; });
            });
        }
    };
    ExpedienteViewComponent.prototype.goToPagePases = function (index) {
        var _this = this;
        this._expService.findPases(this.expId, index, 5).subscribe(function (response) {
            _this.pases = response;
            _this.pagesPases = new Array(Math.ceil(_this.pases.total / _this.pases.size)).map(function (x, i) { return i; });
            _this.curPagePases = index;
        });
    };
    ExpedienteViewComponent.prototype.goToPageSaldos = function (index) {
        var _this = this;
        this._expService.findSaldos(this.expId, index, 5).subscribe(function (response) {
            _this.saldos = response;
            _this.pagesSaldos = new Array(Math.ceil(_this.saldos.total / _this.saldos.size)).map(function (x, i) { return i; });
            _this.curPageSaldos = index;
        });
    };
    ExpedienteViewComponent.prototype.nextPagePases = function () {
        var _this = this;
        if (this.curPagePases < this.pagesPases.length) {
            this.curPagePases = this.curPagePases + 1;
            this._expService.findPases(this.expId, this.curPagePases, 5).subscribe(function (response) {
                _this.pases = response;
                _this.pagesPases = new Array(Math.ceil(_this.pases.total / _this.pases.size)).map(function (x, i) { return i; });
            });
        }
    };
    ExpedienteViewComponent.prototype.nextPageSaldos = function () {
        var _this = this;
        if (this.curPageSaldos < this.pagesSaldos.length) {
            this.curPageSaldos = this.curPageSaldos + 1;
            this._expService.findSaldos(this.expId, this.curPageSaldos, 5).subscribe(function (response) {
                _this.saldos = response;
                _this.pagesSaldos = new Array(Math.ceil(_this.saldos.total / _this.saldos.size)).map(function (x, i) { return i; });
            });
        }
    };
    // getUrlAdjuntoEscrito(escid: number): any {
    //     //return this._expService.urlSer() + "expediente/" + this.expId + "/escrito/" + escid + "/adjuntos";
    //     this._expService.adjuntosEscrito(this.expId, escid).subscribe(response => {
    //         return response;
    //     });
    // }
    ExpedienteViewComponent.prototype.getUrlAdjuntoEscrito = function (escid) {
        var _this = this;
        var fileName = "adjunto_escrito.zip";
        var a = document.createElement("a");
        document.body.appendChild(a);
        this._comService.emitBlocking(true);
        this._expService.adjuntosEscrito(this.expId, escid).subscribe(function (res) {
            var file = new Blob([res], { type: 'application/zip' });
            var fileURL = window.URL.createObjectURL(file);
            _this._comService.emitBlocking(false);
            a.href = fileURL;
            a.download = fileName;
            a.click();
        }, function (error) {
            _this._comService.emitBlocking(false);
            alert("No se pudo descargar el adjunto");
        });
    };
    // getUrlAdjunto(id: number): string {
    //     return this._expService.urlSer() + "actuaciones/" + id + "/adjuntosact";
    // }
    ExpedienteViewComponent.prototype.getUrlAdjunto = function (id) {
        var _this = this;
        var fileName = "adjuntos.zip";
        var ab = document.createElement("a");
        document.body.appendChild(ab);
        this._comService.emitBlocking(true);
        this._actService.adjuntosAct(id.toString()).subscribe(function (res) {
            var file = new Blob([res], { type: 'application/zip' });
            var fileURL = window.URL.createObjectURL(file);
            _this._comService.emitBlocking(false);
            ab.href = fileURL;
            ab.download = fileName;
            ab.click();
        }, function (error) {
            _this._comService.emitBlocking(false);
            alert("No se pudo descargar el adjunto");
        });
    };
    ExpedienteViewComponent.prototype.reimprimirCmp = function (tasa) {
        var _this = this;
        var fileName = "comprobante_tasa" + tasa.id + ".pdf";
        var a = document.createElement("a");
        document.body.appendChild(a);
        this._comService.emitBlocking(true);
        //console.log("reimprimir tasa " + JSON.stringify(tasa));
        this._tService.reimprimir(JSON.stringify(tasa)).subscribe(function (response) {
            _this._comService.emitBlocking(false);
            var file = new Blob([response], { type: 'application/pdf' });
            var fileURL = window.URL.createObjectURL(file);
            a.href = fileURL;
            a.download = fileName;
            a.click();
        }, function (error) {
            _this._comService.emitBlocking(false);
        });
    };
    ExpedienteViewComponent.prototype.alternateToggle = function () {
        if (this.showList) {
            this.showList = false;
        }
        else {
            this.showList = true;
        }
    };
    ExpedienteViewComponent.prototype.getFavIcon = function (esFav) {
        if (esFav === 1)
            return "fa fa-star";
        else
            return "fa fa-star-o";
    };
    ExpedienteViewComponent.prototype.addFavorito = function () {
        var _this = this;
        if (this.expediente.esFav === 1) {
            this._expService.delFavorito(this.expId, KeycloakService.getLoggedUser()).subscribe(function (response) {
                _this.expediente.esFav = response;
            });
        }
        else {
            this._expService.addFavorito(this.expId, KeycloakService.getLoggedUser()).subscribe(function (response) {
                _this.expediente.esFav = response;
            });
        }
    };
    /* Presentar escrito -> open File dialog -> select doc/docx/pdf -> onClose show modal Escritos */
    ExpedienteViewComponent.prototype.validarAcumulado = function () {
        if (this.noEsOculto) {
            if (this.expediente.acumuladoEn !== "" && this.expediente.acumuladoEn != null) {
                this.mensajeConfigSource = new MensajeConfig("Causa Acumulada", false, "", true, "Aceptar");
                this.msgPopup.showMessage("La causa se encuentra acumulada a " + this.expediente.acumuladoEn);
            }
            else {
                document.getElementById('uploadBtn-' + this.instanceId).click();
            }
        }
    };
    ExpedienteViewComponent.prototype.fileChangeEvent = function (fileInput) {
        this._comService.emitBlocking(true);
        if (fileInput.target.files.length === 1) {
            if (fileInput.target.files[0].type !== "application/pdf"
                && fileInput.target.files[0].type !== "application/msword"
                && fileInput.target.files[0].type !== "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
                this._comService.emitBlocking(false);
                alert("Debe seleccionar un PDF o un DOC(X)");
                this.modalEscritoEvent(SIGNER_STATUS.CLOSED.code);
            }
            else {
                var reader = new FileReader();
                var fileName64 = fileInput.target.files[0].name;
                fileName64 = fileName64.replace(/[\u00A0-\u2666\u00F1\u00D1]/g, function (c) {
                    return '&#' + c.charCodeAt(0) + ';';
                });
                //console.log("REMPALAZO NAME FILE " + fileInput.target.files[0].name + " TO " + fileName64);
                var ext = fileName64.substring(fileName64.indexOf("."));
                //console.log("extension file " + ext);
                //console.log("name sin extension " + fileName64.substring(0, fileName64.indexOf(".")));
                //console.log("no mas de 30 " + fileName64.substring(0, fileName64.indexOf(".")).substring(0, 15));
                fileName64 = fileName64.substring(0, fileName64.indexOf(".")).substring(0, 80) + ext;
                var that = this;
                reader.onloadend = function () {
                    that._expService.uploadDocumento("escrito;" + fileName64, reader.result).subscribe(function (result) {
                        that.escritoUploaded(result);
                        document.getElementById('uploadBtn-' + that.instanceId).onclick = function () { document.getElementById('uploadBtn-' + that.instanceId).value = null; };
                        // that._comService.emitBlocking(false);
                    }, function (error) {
                        var exc = ServiceException.parse(error.json());
                        //console.log(exc.toString());
                        alert(exc.description);
                        that.modalEscritoEvent(SIGNER_STATUS.CLOSED.code);
                        // that._comService.emitBlocking(false);
                    });
                };
                if (fileInput.target.files[0]) {
                    reader.readAsDataURL(fileInput.target.files[0]);
                }
            }
        }
        else {
            // canceló
            this.modalEscritoEvent(SIGNER_STATUS.CLOSED.code);
        }
    };
    ExpedienteViewComponent.prototype.escritoUploaded = function (fileId) {
        var _this = this;
        //console.log("upload: " + fileId);
        // después de elegir archivo ...
        var escrito = new Escrito();
        escrito.expId = this.expId;
        if (this.expediente) {
            escrito.anio = this.expediente.anio;
            escrito.numero = this.expediente.numero;
            escrito.tipo = this.expediente.tipo;
            escrito.organismo = this.expediente.organismo;
            escrito.usuCodigo = KeycloakService.getLoggedUser();
        }
        //$('#uploadBtn-' + this.instanceId)
        this.escPresentar.onStatusChange.subscribe(function (event) { _this.modalEscritoEvent(event); });
        this.escPresentar.open(escrito, fileId.name, fileId.id);
        $('#presentar-escrito-' + this.instanceId).modal({
            backdrop: 'static',
            keyboard: false
        });
        $('#presentar-escrito-' + this.instanceId).modal('show');
    };
    ExpedienteViewComponent.prototype.modalEscritoEvent = function (event) {
        switch (event) {
            case SIGNER_STATUS.SIGNOK.code:
                //console.log("escrito subido y firmado!");
                this.mensajeConfigSource = new MensajeConfig("Presentar Escrito", false, "", true, "Aceptar");
                this.msgPopup.showMessage("El escrito se subio correctamente");
                this.escritos = null;
                this.getEscritos();
                break;
            case SIGNER_STATUS.CLOSED.code:
                $('#presentar-escrito-' + this.instanceId).modal('hide');
                //console.log("modal escritos cerrado");
                break;
        }
    };
    ExpedienteViewComponent.prototype.onClickShowEscPopup = function (id) {
        this.escPopup.loadEsc(id, false);
    };
    ExpedienteViewComponent.prototype.onClickShowEscCompPopup = function (id) {
        this.escPopup.loadEsc(id, true);
    };
    ExpedienteViewComponent.prototype.downloadEvent = function (s) {
        if (this.noEsOculto) {
            if (this.permisoDescargaPersonalizada) {
                this.expDownload.instanceId = this.instanceId;
                this.expDownload.openPopup(this.expediente);
                //console.log("expediente-download instancia: " + this.instanceId);
                $('#expediente-download-' + this.instanceId).modal({
                    backdrop: 'static',
                    keyboard: false
                });
                $('#expediente-download-' + this.instanceId).modal('show');
            }
            else {
                if (this.usarDescargaExpWS) {
                    //descarga por ws
                    //conectar ws
                    this.connectWS();
                    //this.downloadExpThread();
                }
                else {
                    this.downloadExp();
                }
            }
        }
    };
    ExpedienteViewComponent.prototype.onClickNewTasa = function () {
        //this.tasPopup.newTasa();
        if (this.expediente.monto === "0" || this.expediente.monto === "0.0" || this.expediente.monto === "0.00" || this.expediente.monto === "nu" || this.expediente.monto === "null") {
            this.mensajeConfigSource = new MensajeConfig("Tasas Judiales", true, "Aceptar", false);
            this.msgPopup.showMessage("El monto de la causa no está actualizado.");
        }
        else {
            //    this.mensajeConfigSource = new MensajeConfig("Tasas Judiales",true, "Continuar");
            //    this.msgPopup.showMessage("El monto de la causa es " + this.expediente.monto);
            this.onConfirmMonto(BUTTON_CLICK.Aceptar);
        }
    };
    ExpedienteViewComponent.prototype.onConfirmMonto = function (res) {
        if (BUTTON_CLICK.Aceptar === res) {
            //document.getElementById('_tasa').click();
            this.tasPopup.newTasa(this.expediente);
            $('#tasa-popup-' + this.instanceId).modal({
                backdrop: 'static',
                keyboard: false
            });
            $('#tasa-popup-' + this.instanceId).modal('show');
        }
    };
    ExpedienteViewComponent.prototype.onClickOpenTasa = function () {
        this.tasPopup.newTasa(this.expediente);
    };
    ExpedienteViewComponent.prototype.imprimirReporte = function (ev) {
        var _this = this;
        if (this.noEsOculto) {
            var that = this;
            this._comService.emitBlocking(true);
            var fileName = 'comprobante' + this.expediente.numero + '.pdf';
            var a = document.createElement("a");
            document.body.appendChild(a);
            this._expService.imprimirReporte(JSON.stringify(this.expediente.expId), false, KeycloakService.getLoggedUser()).subscribe(function (response) {
                var file = new Blob([response], { type: 'application/pdf' });
                var fileURL = window.URL.createObjectURL(file);
                _this._comService.emitBlocking(false);
                a.href = fileURL;
                a.download = fileName;
                a.click();
            }, function (error) {
                //this.showErrorMessage("No se pudo generar el Reporte");
                _this._comService.emitBlocking(false);
            });
        }
    };
    ExpedienteViewComponent.prototype.onClickPagar = function (tasa) {
        var _this = this;
        if (tasa.id) {
            this._expService.pagarTasa(tasa.id).subscribe(function (data) {
                if (data && data.error) {
                    alert(data.error);
                }
                else {
                    _this._comService.emitBlocking(false);
                    window.open(data.AccessLink, "_blank");
                    tasa.estado = "Procesando Pago ";
                }
            }, function (error) {
                console.log(error);
                alert('No se pudo generar el Reporte');
            });
        }
    };
    ExpedienteViewComponent.prototype.validateBtnPagTas = function (tasa) {
        var fechaParts = tasa.fechaVto.split('/'); // Divide el string en día, mes y año
        var formattedDate = new Date(fechaParts[2] + "-" + fechaParts[1] + "-" + fechaParts[0]); // Reordena a formato YYYY-MM-DD
        return new Date(formattedDate) > new Date() && tasa.estado.toLowerCase() == "pendiente";
    };
    ExpedienteViewComponent.prototype.printInvoice = function (token) {
        //token = "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";
        if (document.getElementById("supervielle") !== null) {
            document.getElementById("supervielle").remove();
        }
        var form = document.createElement("form");
        form.setAttribute("id", "supervielle");
        form.target = "view";
        form.method = "POST";
        form.action = "https://qarecaudaciones.supervielle.com.ar/pago";
        var params = {
            "version": "1.0",
            "token": token
        };
        for (var i in params) {
            if (params.hasOwnProperty(i)) {
                var input = document.createElement('input');
                input.type = 'hidden';
                input.name = i;
                input.value = params[i];
                form.appendChild(input);
            }
        }
        document.body.appendChild(form);
        form.submit();
        //window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        window.open('', 'view');
    };
    ExpedienteViewComponent.prototype.ngOnDestroy = function () {
        if (this.messageSubscription) {
            this.messageSubscription.unsubscribe();
            //console.log("Desuscrito de los mensajes del WebSocket");
        }
        // Desconectar el WebSocket si es necesario
        //console.log("ngOnDestroy desconectar el WebSocket");
        this._ws.disconnect();
        this._ws = null;
    };
    ExpedienteViewComponent.prototype.connectWS = function () {
        var _this = this;
        // URL del WebSocket
        var wsUrl = SharedService.getProp("services_url")
            .replace("/api/", "/")
            .replace("http", "ws") + "manager-websocket";
        //console.log("url ws " + wsUrl);
        //console.log("Estableciendo conexion con el ws");
        this._ws.connect(wsUrl);
        this._ws.onOpen.subscribe(function () {
            //console.log("Conexión WebSocket establecida");
        });
        this.messageSubscription = this._ws.onMessage.subscribe(function (response) {
            //console.log("Mensaje recibido del ws: " + JSON.stringify(response));
            _this.processMessage(response);
        });
        // Manejar cierre de conexión (aún no se cierra)
        this._ws.onClose.subscribe(function () {
            //console.log("Conexión ws cerrada");
            _this._comService.emitBlocking(false);
        });
        // Manejar errores del WebSocket
        this._ws.onError.subscribe(function (error) {
            //console.log("Error en ws");
            alert("Ha ocurrido un problema con el WebSocket");
            _this._ws.disconnect();
            _this._comService.emitBlocking(false);
        });
    };
    ExpedienteViewComponent.prototype.processMessage = function (event) {
        //console.log("Mensaje recibido del ws: " + event.data);
        //console.log("Mensaje event " + JSON.stringify(event));
        var message = event.command;
        switch (message) {
            case 'init':
                //console.log("sessionId: " + event.data);
                this.sessionId = event.data;
                //console.log("sessionId: " + this.sessionId);
                //console.log("iniciando descarga: " + this.sessionId);
                this.downloadExpThread();
                break;
            case 'finDescargaExpedienteThread':
                //console.log("Proceso descarga expediente finalizado");
                this.getResultadoDescargaExpediente();
                break;
            case 'errorDescargaExpedienteThread':
                //console.log("Error proceso de descarga de expediente");
                this._comService.emitBlocking(false);
                alert('Ocurrió un error en el proceso de descarga de expediente.');
                this.destroyWS();
                break;
            default:
        }
    };
    ExpedienteViewComponent.prototype.downloadExp = function () {
        var _this = this;
        this._comService.emitBlocking(true);
        var fileName = "expediente_" + this.expediente.numero + ".pdf";
        var a = document.createElement("a");
        document.body.appendChild(a);
        this._expService.downloadExp(this.expId, KeycloakService.getLoggedUser()).subscribe(function (res) {
            var file = new Blob([res], { type: 'application/pdf' });
            var fileURL = window.URL.createObjectURL(file);
            _this._comService.emitBlocking(false);
            a.href = fileURL;
            a.download = fileName;
            a.click();
        }, function (error) {
            //var exc = ServiceException.parse(error.json());
            //console.log(exc.toString());
            _this._comService.emitBlocking(false);
            alert("No se pudo generar el PDF");
        });
    };
    ExpedienteViewComponent.prototype.downloadExpThread = function () {
        var _this = this;
        this._comService.emitBlocking(true);
        this._expService.downloadExpThread(this.expId, KeycloakService.getLoggedUser(), this.sessionId).subscribe(function (res) {
            //console.log("respuesta downloadExpThread " + res);
            if (res) {
                _this.uuidDescargaThread = res;
            }
            else {
                _this._comService.emitBlocking(false);
                alert("No se pudo generar el PDF");
                _this.destroyWS();
            }
        }, function (error) {
            //var exc = ServiceException.parse(error.json());
            //console.log(exc.toString());
            _this._comService.emitBlocking(false);
            alert("No se pudo generar el PDF");
            _this.destroyWS();
        });
    };
    ExpedienteViewComponent.prototype.getResultadoDescargaExpediente = function () {
        var _this = this;
        if (this.uuidDescargaThread != null && this.uuidDescargaThread != "") {
            var fileName = "expediente_" + this.expediente.numero + ".pdf";
            var a = document.createElement("a");
            document.body.appendChild(a);
            this._expService.getResultadodownloadExpThread(this.uuidDescargaThread).subscribe(function (res) {
                var file = new Blob([res], { type: 'application/pdf' });
                var fileURL = window.URL.createObjectURL(file);
                _this._comService.emitBlocking(false);
                a.href = fileURL;
                a.download = fileName;
                a.click();
                _this.destroyWS();
            }, function (error) {
                //var exc = ServiceException.parse(error.json());
                //console.log(exc.toString());
                _this._comService.emitBlocking(false);
                alert("No se pudo generar el PDF");
                _this.destroyWS();
            });
        }
    };
    ExpedienteViewComponent.prototype.destroyWS = function () {
        if (this.messageSubscription) {
            this.messageSubscription.unsubscribe();
            //console.log("Desuscrito de los mensajes del WebSocket");
        }
        // Desconectar el WebSocket si es necesario
        //console.log("ngOnDestroy desconectar el WebSocket");
        this._ws.disconnect();
        //this._ws = null;
    };
    ExpedienteViewComponent.prototype.onClickShowCompPartePopup = function (rep_codigo, codigo, vinId) {
        //console.log("abrir popup comprobante: rep_codigo" + rep_codigo + "per_id " + codigo + " vinId " + vinId);
        this.repPopup.loadRepresentanteQr(this.expId, codigo, rep_codigo, vinId);
    };
    return ExpedienteViewComponent;
}());
__decorate([
    ViewChild(EscritoPresentarComponent),
    __metadata("design:type", EscritoPresentarComponent)
], ExpedienteViewComponent.prototype, "escPresentar", void 0);
__decorate([
    ViewChild(ActuacionPopupComponent),
    __metadata("design:type", ActuacionPopupComponent)
], ExpedienteViewComponent.prototype, "actPopup", void 0);
__decorate([
    ViewChild(EscritoPopupComponent),
    __metadata("design:type", EscritoPopupComponent)
], ExpedienteViewComponent.prototype, "escPopup", void 0);
__decorate([
    ViewChild(TasasPopupComponent),
    __metadata("design:type", TasasPopupComponent)
], ExpedienteViewComponent.prototype, "tasPopup", void 0);
__decorate([
    ViewChild(PopupRecaptcha),
    __metadata("design:type", PopupRecaptcha)
], ExpedienteViewComponent.prototype, "captchaPopup", void 0);
__decorate([
    ViewChild(ExpedienteDownloadComponent),
    __metadata("design:type", ExpedienteDownloadComponent)
], ExpedienteViewComponent.prototype, "expDownload", void 0);
__decorate([
    ViewChild(RepresentanteQrPopupComponent),
    __metadata("design:type", RepresentanteQrPopupComponent)
], ExpedienteViewComponent.prototype, "repPopup", void 0);
__decorate([
    ViewChild(Message),
    __metadata("design:type", Message)
], ExpedienteViewComponent.prototype, "msgPopup", void 0);
__decorate([
    ViewChild(Message),
    __metadata("design:type", Message)
], ExpedienteViewComponent.prototype, "msgPopupAct", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], ExpedienteViewComponent.prototype, "expId", void 0);
__decorate([
    Input(),
    __metadata("design:type", Novedad)
], ExpedienteViewComponent.prototype, "novedad", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ExpedienteViewComponent.prototype, "showToolbar", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ExpedienteViewComponent.prototype, "showToolbarMenu", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ExpedienteViewComponent.prototype, "mostrarZocalo", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ExpedienteViewComponent.prototype, "mostrarZocaloDespacho", void 0);
ExpedienteViewComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'expediente-view',
        templateUrl: 'expediente-view.component.html',
    }),
    __metadata("design:paramtypes", [Http,
        TasasService,
        ExpedienteService,
        ActuacionService,
        CommonService,
        WebSocketService])
], ExpedienteViewComponent);
export { ExpedienteViewComponent };
//# sourceMappingURL=expediente-view.component.js.map